import { SubscriberForgottenInfoModel } from "./SubscriberForgottenInfoModel";
import { SubscriberForgottenModel } from "./SubscriberForgottenModel";

export class SubscriberForgottenWrapperModel {
    subscriber: SubscriberForgottenModel = new SubscriberForgottenModel()
    info: SubscriberForgottenInfoModel = new SubscriberForgottenInfoModel()
    loadingListAction: boolean = false

    constructor(s?:Partial<SubscriberForgottenWrapperModel>) {
        Object.assign(this, s)

        this._parseSubscriber()
        this._parseInfo()
    }

    private _parseSubscriber():void {
        this.subscriber = new SubscriberForgottenModel(this.subscriber)
    }

    private _parseInfo():void {
        this.info = new SubscriberForgottenInfoModel(this.info)
    }
}
